var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2657 4.63867H20.5591C20.3199 4.63867 20.0928 4.74854 19.9463 4.93652L9.8804 17.688L5.05374 11.5723C4.98072 11.4796 4.88766 11.4046 4.78152 11.353C4.67539 11.3014 4.55895 11.2746 4.44095 11.2744H2.7344C2.57083 11.2744 2.4805 11.4624 2.5806 11.5894L9.26761 20.061C9.58011 20.4565 10.1807 20.4565 10.4956 20.061L22.4195 4.95117C22.5196 4.82666 22.4292 4.63867 22.2657 4.63867Z",
    fill: "#1F9C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/CheckOutlined.d30ef9b397dd4dda6d14b69be71df911.svg";
export { ForwardRef as ReactComponent };